import React, { Component } from 'react';
import { Row, Badge, Col, Alert, Button, Container,
            ButtonGroup, ListGroup, ListGroupItem,
            Modal, ModalBody,ModalHeader, } from 'reactstrap';
import { fetchWorkOrdersUploadedImage, fetchWorkOrdersDriverList } from "../../../redux/actions/aTransporter-WorkOrdersUpload";
import UploadPhoto from "./UploadPhoto"
import { connect } from 'react-redux';
import { BarLoader } from 'react-spinners';
import langaugeFactory from './language'
import {toast, ToastContainer}  from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

class WorkOrdersPhotoUpload extends Component {

    constructor(props) {
        const INDONESIA = 1
        super(props);
        this.props.fetchWorkOrdersDriverList(this.props.match.params.key)
        this.state = {
            modalUpload : false,
            language: langaugeFactory(INDONESIA),
            progressOfSkipWo: null,
            progressOfUpload: {},
            tempProgressOfUpload: {},
            uploadCheckInProgress: true
        }
        setTimeout(() => { this.loadProgress(0) }, 300)
    }

    loadProgress = async (depth) => {
        const {language} = this.state
        const {woDriverList} = this.props
        const MAX_DEPTH_TRY = 4 // make sure its not try load api data forevah, around 2 seconds of try!
        if(depth === MAX_DEPTH_TRY)
            return

        if(!woDriverList){
            setTimeout(() => { this.loadProgress(depth+1) }, 300)
            return 
        }

        if(woDriverList.length === 0){
            setTimeout(() => { this.loadProgress(depth+1) }, 300)
            return
        }

        //buat ngakalin state yang kasih updatenya selalu dari yg proses sebelumnya
        woDriverList.push({
            delivery_id: -1,
            id: -1
        })

        let currentDOId = woDriverList[0].delivery_id
        let theWo = woDriverList[0].wo_number

        this.insertUpdateSkipLs(currentDOId, theWo, false)
        let loop = 0

        toast.info(language.uploadCheck, {autoClose: woDriverList.length * 300,})

        let woDriverLoop = setInterval(async () => {
                this.updateUploadProgress(
                    woDriverList[loop].delivery_id,
                    woDriverList[loop].id,
                )
                if(loop+1 >= woDriverList.length){
                    clearInterval(woDriverLoop)
                }
                loop += 1
        }, 300); 
        
        setTimeout(() => {
            console.log(this.state.tempProgressOfUpload)
            this.setState({
                progressOfSkipWo : this.getCurrentWoSeqLsbyCurrentDOId(currentDOId),
                progressOfUpload : this.state.tempProgressOfUpload,
                uploadCheckInProgress: false
            }, ()=> { toast.dismiss()})
        }, woDriverList.length * 300)

    }

    updateUploadProgress = async (currentDOId, currentWoId) => {
        const {uploadedWoImageData} = this.props
        await this.props.fetchWorkOrdersUploadedImage(
            currentDOId,
            currentWoId,
        )
        let t  = this.state.tempProgressOfUpload
        let id = uploadedWoImageData[0]? uploadedWoImageData[0].id_work_order : "-"
        t[id] = uploadedWoImageData[0]? true : false
        this.setState({
            tempProgressOfUpload : t
        })
    }

    insertUpdateSkipLs = (currentDOId, theWo, isUpdate) => {
        if (!localStorage.getItem('woproffuploader_v1')) {
            let obj = {}
            obj[currentDOId]= {"current_wo_seq" : theWo}
            localStorage.setItem('woproffuploader_v1', JSON.stringify(obj));
            return
        }

        let currentObj = JSON.parse(localStorage.getItem('woproffuploader_v1'))
        let obj = currentObj
        if(!currentObj[currentDOId]) {
            obj[currentDOId] = {"current_wo_seq" : theWo}
            localStorage.setItem('woproffuploader_v1', JSON.stringify(obj));
            return
        }

        if(isUpdate){
            obj[currentDOId]["current_wo_seq"] = theWo
            localStorage.setItem('woproffuploader_v1', JSON.stringify(obj));
        }
    }

    getCurrentWoSeqLsbyCurrentDOId = (currentDOId) => {
        let currentObj = JSON.parse(localStorage.getItem('woproffuploader_v1'))
        return currentObj[currentDOId]["current_wo_seq"]
    }

    skipClicked = (data, currentIndex=-1) => {
        let nextIndex = 0
        const {progressOfSkipWo} = this.state
        if(currentIndex === -1){
            let getIndexByWo = data.findIndex(d => progressOfSkipWo === d.wo_number)
            currentIndex = getIndexByWo
        }
        if(currentIndex+1 < data.length-1){
            nextIndex = currentIndex+1
        }
        let currentDOId = data[nextIndex].delivery_id
        let theWo = data[nextIndex].wo_number
        this.insertUpdateSkipLs(currentDOId, theWo, true)
        this.setState({
            progressOfSkipWo : this.getCurrentWoSeqLsbyCurrentDOId(currentDOId),
            currentIndex: nextIndex
        })
    }

    toggleOpenUpload = (_idDo, _idWo, woNumber) => {
        this.setState({
            modalUpload: !this.state.modalUpload,
            idDo: _idDo,
            idWo: _idWo,
            selectedWoNumber : woNumber
        })
        this.props.fetchWorkOrdersUploadedImage(
            _idDo,
            _idWo,
        )
    }

    toggleCloseUpload = (uploadSuccess) => {
        this.setState({
            modalUpload: !this.state.modalUpload,
            uploadCheckInProgress: true
        }, ()=> {
            const {language} = this.state
            const {woDriverList} = this.props
            let loop = 0
            
            toast.info(language.uploadCheck, {autoClose: woDriverList.length * 300,})
            
            let woDriverLoop = setInterval(() => {
                    this.updateUploadProgress(
                        woDriverList[loop].delivery_id,
                        woDriverList[loop].id,
                    )
                    if(loop+1 >= woDriverList.length){
                        clearInterval(woDriverLoop)
                    }
    
                    loop += 1
            }, 300); 
            
            setTimeout(() => {
                this.setState({
                    progressOfUpload : this.state.tempProgressOfUpload,
                    uploadCheckInProgress: false
                }, ()=> { 
                    if(uploadSuccess){
                      this.skipClicked(woDriverList) 
                    }
                    toast.dismiss()
                })
            }, woDriverList.length * 300)
        })
    }

    refreshImage = () => {
        this.props.fetchWorkOrdersUploadedImage(
            this.state.idDo,
            this.state.idWo,
        )
    }

    WoListToUpload = (props) => {
        const {language, progressOfSkipWo, progressOfUpload, uploadCheckInProgress} = this.state
        const {woDriverList, totalWo} = this.props
        return(
            <React.Fragment>
            {totalWo > 0?
                <Alert color="info">
                    <center>
                        <h4>{language.title}{woDriverList[0].do_number} ({totalWo} WO)</h4>
                        <h4>{language.driverName}{woDriverList[0].driver_name}{" | "}{language.fleet}{woDriverList[0].fleet_plate}</h4>
                    </center>
                </Alert>
                :
                <Alert color="danger">
                    <center>
                        <h3>{language.noDeliveryFound}</h3>
                    </center>
                </Alert>
            }
                <ListGroup>
                    {woDriverList.map((data, currentIndex) => (
                        <React.Fragment>
                            {currentIndex < woDriverList.length-1?
                                <ListGroupItem> 
                                    <Row>
                                        <Col md={6} xs={12}>
                                            <h4>{currentIndex+1}.) WO : {data.wo_number}{" "}{progressOfUpload[data.id]?   
                                                    <Badge color="success" 
                                                        style={{fontSize: 10, "vertical-align": "middle",  "margin-top": "-0.5em" }} 
                                                        pill>{language.done}</Badge> : null
                                                    }
                                            </h4> 
                                            <dt>{language.woCustomer}</dt>
                                            <dd>{data.main_customer? data.main_customer : "-"}</dd>

                                            <dt>{language.woCustomerPhone}</dt>
                                            <dd>{data.main_customer_phone? data.main_customer_phone : "-" }</dd>
                                            
                                            <dt>
                                                {language.woAddress} {" "}
                                                <Button color="success" size="sm"
                                                    onClick={() => window.open("https://www.google.co.id/maps/search/"+ data.lat + "," + data.lng +"?hl=id", '_blank')}>
                                                    <i class="fa fa-map-marker"></i> 
                                                </Button>
                                            </dt>
                                            <dd>{data.wo_destination_name? data.wo_destination_name : "-"}</dd>

                                            <dt>{language.woTarget}</dt>
                                            <dd>{data.est_arrival_time? data.est_arrival_time : "-"}</dd>
                                        </Col>
                                    </Row>
                                    <Button color={this.isButtonDisable(progressOfSkipWo !== data.wo_number || uploadCheckInProgress)} size="lg" 
                                            onClick={() => this.toggleOpenUpload(data.delivery_id, data.id, data.wo_number)}
                                            disabled={progressOfSkipWo !== data.wo_number || uploadCheckInProgress}>
                                        <i class="fa fa-file-image"></i> {language.uploadButton}
                                    </Button>
                                    <Button style={{"margin-left":"7px"}}
                                        color={this.isButtonDisable(progressOfSkipWo !== data.wo_number || uploadCheckInProgress)} size="lg"
                                        disabled={progressOfSkipWo !== data.wo_number || uploadCheckInProgress}
                                        onClick={() => this.skipClicked(woDriverList, currentIndex)}>
                                        <i class="fa fa-file-image"></i> {language.skip}
                                    </Button>
                                </ListGroupItem> : null}
                        </React.Fragment>
                    ))}
                </ListGroup>
            </React.Fragment>
        )
    }

    isButtonDisable = (condition) => {
        if(condition)
            return "secondary"
        return "primary"
    }

    WoImagesList = (props) => {
        const {language} = this.state
        const {uploadedWoImageData, totalWoImage} = this.props
        return(
            <React.Fragment>
                {
                    this.props.inProgress ? 
                    <center><BarLoader color={'#123abc'} loading={this.props.inProgress}/> <br /> {language.pleaseWait}</center>
                    : 
                    (
                        this.props.success ? 
                            <React.Fragment>
                                <Alert color="info">{
                                    totalWoImage === 0 ? 
                                            language.noImage
                                            : 
                                            language.enlarge}
                                </Alert>
                                <ListGroup style={{"flex-direction":"row", 
                                                        "display": "block",
                                                        "margin-left": "auto",
                                                        "margin-right": "auto"}}>
                                    {uploadedWoImageData.map(item => (
                                        <ListGroupItem> 
                                            <this.WoImageItem image={item}/>
                                        </ListGroupItem>
                                    ))}
                                </ListGroup>
                            </React.Fragment>
                        :
                        <center>Error fetching your data... <br/><br/> 
                            <Button className="btn btn-primary" color="primary" size="md" 
                                    disabled={this.props.inProgress} 
                                    onClick={() => this.props.fetchWorkOrdersUploadedImage(
                                                props.idDo,
                                                props.idWo
                                            )}>
                                <i className="fa fa-refresh"></i> 
                                Try again
                            </Button>
                        </center>   
                    )
                } 
                <br /> <br />
                <UploadPhoto 
                    toggleCloseUpload={this.toggleCloseUpload}     
                    refreshImage={() => this.refreshImage()} 
                    idWo = {this.state.idWo}
                    woNumber = {this.state.selectedWoNumber}
                    language={language}
                    totalWoImage= {totalWoImage}
                /> 
            </React.Fragment>
        )
    }

    WoImageItem = (props) => {
        const {image} = props
        return(
            <React.Fragment>
                <Row >
                    <Col xs="12" md="12">
                        <a href={image.link} target="_blank">
                            <img width="100%" height="300"
                                border="0" align="center" 
                                alt="Gambar WO"
                                src={image.link}/>
                        </a>
                        {" "}
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col xs="10" md="10">
                     <b>{image.desc}</b>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    changeLanguage = (languageId) => {
        this.setState({
            language: langaugeFactory(languageId)
        })
    }

    render(){
        const {language} = this.state
        const INDONESIA_LANG_CODE = 1
        const ENGLISH_LANG_CODE = 2
        return(
            <Container fluid style={{"max-width": "1280px"}}>
                <div style={{"text-align": "right"}}>
                <b>{language.languageSelect} &nbsp;&nbsp;&nbsp;</b>
                <ButtonGroup >
                    <Button color="primary" onClick={() => this.changeLanguage(INDONESIA_LANG_CODE)}>
                        ID
                    </Button>
                    <Button color="primary" onClick={() => this.changeLanguage(ENGLISH_LANG_CODE)}> 
                        EN
                    </Button>
                </ButtonGroup>
                <br ></br><br ></br>
                </div>
                {
                    this.props.inProgressWoDriverList && this.state.progressOfUpload === {}? 
                    <center><BarLoader color={'#123abc'} loading={this.props.inProgress && this.state.progressOfUpload === {}}/> <br /> {language.pleaseWait}</center>
                    : 
                    (
                        this.props.successWoDriverList ? 
                            <React.Fragment>
                                <this.WoListToUpload />
                                <Modal isOpen={this.state.modalUpload} toggle={this.toggleOpenUpload} className={this.props.className} backdrop="static">
                                    <ModalHeader toggle={this.toggleCloseUpload}>{language.uploadFormTitle}  WO {this.state.selectedWoNumber}</ModalHeader>
                                    <ModalBody>
                                        <this.WoImagesList idDo={this.state.idDo} idWo={this.state.idWo}/>
                                    </ModalBody>
                                </Modal>   
                            </React.Fragment>             
                        :
                            <center>Error fetching your data... <br/><br/> 
                                <Button className="btn btn-primary" color="primary" size="md" 
                                        disabled={this.props.inProgressWoDriverList} 
                                        onClick={() => this.props.fetchWorkOrdersDriverList(
                                                    this.props.match.params.id
                                                )}>
                                    <i className="fa fa-refresh"></i> 
                                    Try again
                                </Button>
                            </center> 
                    )
                }
                <ToastContainer position="bottom-right" autoClose={7300} style={{zIndex: 7000}}/>
            </Container>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        uploadedWoImageData: state.woUploadedImageStore.uploadedWoImageData,
        inProgress: state.woUploadedImageStore.inProgress,
        success: state.woUploadedImageStore.success,
        totalWoImage: state.woUploadedImageStore.totalWoImage,

        woDriverList: state.woDriverListStore.woDriverList,
        inProgressWoDriverList: state.woDriverListStore.inProgress,
        successWoDriverList: state.woDriverListStore.success,
        totalWo: state.woDriverListStore.totalWo
      }
}

export default connect(mapStateToProps, {fetchWorkOrdersUploadedImage, fetchWorkOrdersDriverList})(WorkOrdersPhotoUpload);


// WEBPACK FOOTER //
// ./src/views/Transporter/WOPhotoUpload/index.jsx